const getMappedParameterLocalizations = (localizations) => {
    return Object.entries(localizations || {})
        .map(
            ([languageId, value]) =>
                value && {
                    languageId,
                    value,
                }
        )
        .filter(Boolean);
};

export { getMappedParameterLocalizations };
